import { Box } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const NavigationMenuGroups = styled('ul', {
    shouldForwardProp: prop => isPropValid(prop),
})(({ theme, hasVisibleNavigationGroup }) => ({
    margin: '0',
    padding: `${theme.spacing[300]} 0`,
    width: 'var(--cb-category-navigation-menugroup-width)',
    listStyleType: 'none',
    background: theme.color.background.base,
    borderRadius: `0 0 ${theme.borderRadius[100]} ${theme.borderRadius[100]}`,
    '&::before': {
        borderRadius: `0 0 ${theme.borderRadius[100]} ${theme.borderRadius[100]}`,
        boxShadow: `0 1px 5px ${theme.color.border.tertiary}`,
        content: '""',
        height: '100%',
        opacity: hasVisibleNavigationGroup ? 0 : 1,
        position: 'absolute',
        top: 0,
        left: 0,
        width: 'var(--cb-category-navigation-menugroup-width)',
        zIndex: -1,
    },
}));
export const NavigationMenuGroup = styled('li')({
    margin: 0,
});
export const NavigationMenuGroupButton = styled('button', {
    shouldForwardProp: prop => isPropValid(prop),
})(({ theme, isActive }) => ({
    all: 'unset',
    outline: 'revert',
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 7,
    fontSize: theme.typography.fontSize.lg,
    padding: theme.spacing[200],
    width: '100%',
    color: theme.color.font.interactiveBase,
    ...(isActive && {
        background: theme.color.background.interactiveHovered,
    }),
    '&:hover, &:focus': {
        background: theme.color.background.interactiveHovered,
    },
}));
export const NavigationCategories = styled('ul', {
    shouldForwardProp: prop => isPropValid(prop),
})(({ theme, isOpen }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    padding: `${theme.spacing[600]} ${theme.spacing[600]} 0 calc(var(--cb-category-navigation-menugroup-width) + ${theme.spacing[600]})`,
    margin: 0,
    listStyleType: 'none',
    textAlign: 'left',
    width: '100%',
    backgroundColor: theme.color.background.base,
    display: isOpen ? 'block' : 'none',
    zIndex: 6,
    minHeight: '100%',
    columns: 2,
    whiteSpace: 'normal',
    columnGap: theme.spacing[1000],
    [theme.breakpoint.minWidth('lg')]: {
        columns: 4,
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        left: 'var(--cb-category-navigation-menugroup-width)',
        top: 0,
        zIndex: -1,
        height: '100%',
        borderLeft: `1px solid ${theme.color.border.base}`,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: -1,
        height: '100%',
        boxShadow: `0 1px 5px ${theme.color.border.tertiary}`,
        borderRadius: `0 0 ${theme.borderRadius[100]} ${theme.borderRadius[100]}`,
    },
}));
export const NavigationDropdownContainer = styled(Box)(() => ({
    '--cb-category-navigation-menugroup-width': '225px',
    marginLeft: '1rem',
}));
export const NavigationModal = styled('div', {
    shouldForwardProp: prop => isPropValid(prop),
})(({ hasSetGroupId }) => ({
    display: 'flex',
    width: hasSetGroupId ? '128rem' : 'initial',
    maxWidth: 'calc(100vw - var(--cb-spec-container-horizontal-padding) * 2)',
    ':hover': {
        cursor: 'default',
    },
}));
//# sourceMappingURL=CategoryNavigationDropdown.styled.js.map